import { useContext } from 'react';

import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';

import ArgonBox from 'component/Argon/ArgonBox';
import ArgonTypography from 'component/Argon/ArgonTypography';

import FormContext from './ContextForm';

import {
  InputName,
  SelectPrefix,
  PickerBd,
  PickerPolicyDate,
  SelectCountry,
  SelectPkg,
  InputIdCard,
  SelectCardType,
  InputEmployer,
  InputEmployerId,
  InputAddress1,
  AutoCompleteDistrict,
  FormField,
} from 'component/basicForm';
import ArgonButton from 'component/Argon/ArgonButton';

function LayoutForm() {
  const { setPageIndex, formData: state, resetState, disabled } = useContext(FormContext);

  const onCommit = (value) => {
    if (value) {
      const curr = value;
      state.setArea(curr?.amphoe);
      state.setProvince(curr?.province);
      state.setZipcode(curr?.zipcode.toString());
    }
  };

  return (
    <>
      <ArgonBox mt={3} mb={8}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={9}>
            <Card sx={{ overflow: 'visible' }}>
              <ArgonBox p={2} lineHeight={1}>
                <ArgonBox>
                  <ArgonTypography variant="h6" fontWeight="medium">
                    ซื้อประกันภัย
                  </ArgonTypography>
                  <ArgonTypography variant="button" fontWeight="regular" color="text">
                    สร้างข้อมูลกรมธรรม์
                  </ArgonTypography>
                </ArgonBox>
                <ArgonBox mt={3}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <ArgonTypography component="label" variant="body2" fontWeight="bold">
                        ส่วนที่ 1: ข้อมูลแรงงาน
                      </ArgonTypography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <SelectPrefix value={state.prefix} setValue={state.setPrefix} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <InputName value={state.name} setValue={state.setName} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <PickerBd value={state.bd} setValue={state.setBd} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <SelectCountry value={state.nationality} setValue={state.setNationality} />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <PickerPolicyDate value={state.policyDate} setValue={state.setPolicyDate} />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <SelectPkg value={state.pkg} setValue={state.setPkg} />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <InputIdCard value={state.idCard} setValue={state.setIdCard} />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <SelectCardType value={state.cardType} setValue={state.setCardType} />
                    </Grid>
                    <Grid item xs={12}>
                      <InputEmployer value={state.employer} setValue={state.setEmployer} />
                    </Grid>
                    <Grid item xs={12}>
                      <InputEmployerId value={state.employerId} setValue={state.setEmployerId} />
                    </Grid>
                    <Grid item xs={12}>
                      <InputAddress1 value={state.address1} setValue={state.setAddress1} />
                    </Grid>
                    <Grid item xs={12}>
                      <AutoCompleteDistrict value={state.district} onChange={state.setDistrict} onCommit={onCommit} />
                    </Grid>
                    <Grid item xs={12}>
                      <FormField placeholder="อำเภอ/เขต" disabled value={state.area} />
                    </Grid>
                    <Grid item xs={12}>
                      <FormField placeholder="จังหวัด" disabled value={state.province} />
                    </Grid>
                    <Grid item xs={12}>
                      <FormField placeholder="รหัสไปรษณีย์" disabled value={state.zipcode} />
                    </Grid>
                  </Grid>
                </ArgonBox>
                <ArgonBox mt={3} width="100%" display="flex" justifyContent="space-between">
                  <ArgonButton sx={{ minWidth: 180 }} variant="gradient" color="error" onClick={resetState}>
                    ล้างฟอร์ม
                  </ArgonButton>
                  <ArgonBox />
                  <ArgonButton
                    sx={{ minWidth: 180 }}
                    variant="gradient"
                    color="success"
                    disabled={disabled}
                    onClick={() => setPageIndex(1)}
                  >
                    ยืนยัน
                  </ArgonButton>
                </ArgonBox>
              </ArgonBox>
            </Card>
          </Grid>
        </Grid>
      </ArgonBox>
    </>
  );
}

export default LayoutForm;
